import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { _onDentalRecordScreen } from "../redux/actions/generalAction";

const useToggleSideMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const recordAddingPath =
      "/dental-identification/projects/case/add-dental-record";

    if (location.pathname === recordAddingPath) {
      dispatch(_onDentalRecordScreen(true)); // Hide side menu on the record-adding screen
    } else {
      dispatch(_onDentalRecordScreen(false)); // Hide side menu on the record-adding screen
    }
  }, [location, dispatch]);
};

export default useToggleSideMenu;
